import {
  Grid,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  TextField,
  Tooltip,
  IconButton,
  Paper,
  Autocomplete
} from "@mui/material"
import { AddCircleOutline, Delete } from "@mui/icons-material"
import { useMemo } from "react"

export default function DetalleComprobante(props) {
  /* ---------------------------- ESTADOS & REFS ----------------------------- */
  const {
    datosCuerpo,
    setdatosCuerpo,
    uuid,
    valorPorcentajes,
    imputaciones,
    setGuardarImputacProveedor,
    imputacionProveedor,
    proveedorSelected,
    comprobanteSelected,
    setimputacionProveedor,
    bloqueoArca
    // montoMaximo
  } = props
  // const [formValues, setFormValues] = useState(datosCuerpo)

  /* ---------------------------- HANDLERS ----------------------------- */
  const handleAddLinea = () => {
    // setFormValues((prevState) => [
    setdatosCuerpo((prevState) => [
      ...prevState,
      {
        subtotal: 0,
        subtotal_iva: 0,
        id_porcentajeiva: comprobanteSelected && comprobanteSelected.id_tipo_comprobante === 11 ? 4 : 1,
        detalle_productos: null,
        uuid_comprobante: uuid,
        usuario: localStorage.getItem("user"),
        id_imputacion: null,
        monto_iva: 0
      },
    ])
  };

  const handleInputChange = (index, field, value) => {
    setdatosCuerpo((prevValues) => {
      const updatedValues = [...prevValues];
      const updatedItem = { ...updatedValues[index], [field]: value };

      if (field === "subtotal") {
        const { iva, total } = calculateSubtotalIva(
          value,
          updatedItem.id_porcentajeiva
        );

        // Guardamos con formato: "1.234,56"
        updatedItem.monto_iva = props.formatNumber(iva.toFixed(2).replace(".", ","));
        updatedItem.subtotal_iva = props.formatNumber(total.toFixed(2).replace(".", ","));
      }

      updatedValues[index] = updatedItem;
      // setTimeout(() => updateDatosCuerpo(updatedValues), 0);
      return updatedValues;
    });
  };

  // console.log("datosCuerpo", datosCuerpo);


  const handlePorcentajeIvaChange = (index, id_porcentajeiva) => {
    setdatosCuerpo((prevValues) => {
      const updatedValues = [...prevValues];
      const updatedItem = { ...updatedValues[index], id_porcentajeiva };

      const { iva, total } = calculateSubtotalIva(
        updatedItem.subtotal,
        id_porcentajeiva
      );

      updatedItem.monto_iva = iva > 0 ? props.formatNumber(
        iva.toString()?.replace(".", ",")
      ) : 0;

      updatedItem.subtotal_iva = total > 0 ? props.formatNumber(
        total.toString()?.replace(".", ",")
      ) : 0;

      updatedValues[index] = updatedItem;

      updateDatosCuerpo(updatedValues);

      return updatedValues;
    });
  };

  const deshacerLinea = (index) => {
    // if (formValues.length > 1) {
    if (datosCuerpo.length > 1) {
      const values = [...datosCuerpo]
      values.splice(index, 1)
      // setFormValues(values)
      setdatosCuerpo(values)
    }
  }

  /* ---------------------------- HELPERS ----------------------------- */
  const updateDatosCuerpo = (updatedValues) => {
    const updatedDatosCuerpo = Object.keys(updatedValues).map((key) => ({
      id_porcentajeiva: updatedValues[key].id_porcentajeiva || null,
      subtotal: updatedValues[key].subtotal || null,
      subtotal_iva: updatedValues[key].subtotal_iva || null,
      detalle_productos: updatedValues[key].detalle_productos || null,
      usuario: localStorage.getItem("user"),
      uuid_comprobante: uuid,
      id_imputacion: updatedValues[key].id_imputacion || null,
      monto_iva: updatedValues[key].monto_iva || null
    }))

    setdatosCuerpo(updatedDatosCuerpo)
  }


  const calculateSubtotalIva = (subtotal, id_porcentajeiva) => {
    // Limpiamos el subtotal que viene con formato visual "1.234,56"
    const subtotalok = typeof subtotal === 'string'
      ? parseFloat(subtotal.replace(/\./g, "").replace(/,/g, "."))
      : subtotal;

    const porcentajeItem = valorPorcentajes.find(
      (item) => item.idporcentaje_iva === id_porcentajeiva
    );

    // Si el valor es el multiplicador (ej: 1.21), lo usamos, sino 1
    const valor = porcentajeItem ? porcentajeItem.valor : 1;

    const iva = subtotalok * (valor - 1);
    const total = subtotalok * valor;

    return {
      iva: iva,
      total: total
    };
  };

  /* ---------------------------- STYLING ----------------------------- */
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
    "& .MuiOutlinedInput-root": {
      "&.Mui-focused fieldset": {
        borderColor: "#1f618d",
      },
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: "#1f618d",
    },
  };

  const combinedOptions = useMemo(() => {
    if (!imputaciones) return [];

    // Marcamos cuáles pertenecen al proveedor para poder agruparlas
    return imputaciones.map(imp => {
      const esDelProveedor = imputacionProveedor?.some(p => p.idimputacion === imp.idimputacion);

      return {
        ...imp,
        category: esDelProveedor ? "Imputaciones" : "Otras "
      };
    }).sort((a, b) => (a.category === "Imputaciones" ? -1 : 1));
    // El sort asegura que las del proveedor aparezcan arriba
  }, [imputaciones, imputacionProveedor]);

  return (
    <div>
      <Paper
        elevation={3}
        sx={{
          background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
          mt: 1,
          p: 3,
          borderRadius: 4,
          borderLeft: "6px solid #1f618d",
        }}
      >

        {Object.keys(datosCuerpo).map((key, index) => (
          <Grid
            container
            spacing={1}
            alignItems="center"
            mt={1}
            key={index}
          >
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                required
                sx={style}
                label="Descripción"
                // autoComplete="off"
                value={datosCuerpo[key].detalle_productos || ""}
                onChange={(e) => handleInputChange(index, "detalle_productos", e.target.value)}
                size="small"
                focused
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={1.5}>
              <TextField
                fullWidth
                sx={style}
                label="Neto"
                disabled={bloqueoArca}
                value={datosCuerpo[key].subtotal || ""}
                onKeyPress={(event) => {
                  const { value } = event.target;
                  if (!/[\d,]/.test(event.key)) event.preventDefault();
                  if (event.key === "," && value.includes(",")) event.preventDefault();
                }}
                onChange={(e) => handleInputChange(index, "subtotal", props.formatNumber(e.target.value))}
                size="small"
                focused
              />
            </Grid>

            <Grid item xs={12} sm={1.7}>
              <FormControl fullWidth size="small" focused required sx={style} disabled={bloqueoArca || comprobanteSelected?.id_tipo_comprobante === 11}>
                <InputLabel>IVA %</InputLabel>
                <Select
                  value={datosCuerpo[key].id_porcentajeiva || ""}
                  onChange={(e) => handlePorcentajeIvaChange(index, e.target.value)}
                  label="IVA %"
                >
                  {valorPorcentajes.map(({ idporcentaje_iva, descripcion }) => (
                    <MenuItem key={idporcentaje_iva} value={idporcentaje_iva}>
                      {descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={1.5}>
              <TextField
                fullWidth
                sx={style}
                label="Monto IVA"
                value={datosCuerpo[key].monto_iva || ""}
                // onChange={(e) => handleInputChange(index, "subtotal_iva", e.target.value)}
                size="small"
                focused
                inputProps={{ readOnly: true }}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Autocomplete
                size="small"
                options={combinedOptions}
                groupBy={(option) => option.category}
                value={combinedOptions.find((opt) => opt.idimputacion === datosCuerpo[key].id_imputacion) || null}
                noOptionsText="No se encontraron resultados"
                onChange={(event, newValue) => {
                  // 1. Actualizamos el valor en el estado del formulario como siempre
                  handleInputChange(index, "id_imputacion", newValue ? newValue.idimputacion : "");

                  // 2. Validamos si la opción elegida es "nueva" para el proveedor
                  if (newValue) {
                    // Verificamos si NO está en la lista de imputaciones actuales del proveedor
                    const existeEnProveedor = imputacionProveedor?.some(
                      (p) => p.idimputacion === newValue.idimputacion
                    );

                    // Si no existe en su lista y no es un proveedor de padrón (según tu lógica)
                    if (!existeEnProveedor && proveedorSelected?.padron === 0) {
                      setGuardarImputacProveedor(true);
                    } else {
                      // Si elige una que ya tenía, o es padrón, podrías querer volverlo a false
                      // (Dependiendo de si quieres que un cambio posterior "anule" la intención de guardado)
                      setGuardarImputacProveedor(false);
                    }
                  }
                }}

                getOptionLabel={(option) => option.descripcion || ""}
                isOptionEqualToValue={(option, value) => option.idimputacion === value.idimputacion}
                renderInput={(params) => (
                  <TextField {...params} label="Imputado a" required focused sx={style} />
                )}
              />
            </Grid>


            <Grid item xs={12} sm={1.3} sx={{ display: "flex", justifyContent: "flex-start" }}>
              <Tooltip title="Eliminar">
                <span>
                  <IconButton
                    sx={{ color: "#e74c3c", p: 0.5, "&:hover": { backgroundColor: "#fadbd8" } }}
                    onClick={() => deshacerLinea(index)}
                    disabled={index === 0 || bloqueoArca}
                  >
                    <Delete fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title="Nueva Línea">
                <span>
                  <IconButton
                    disabled={index !== Object.keys(datosCuerpo).length - 1 || !datosCuerpo[key].subtotal || bloqueoArca}
                    sx={{ color: "#1f618d", p: 0.5, "&:hover": { backgroundColor: "#d4e6f1" } }}
                    onClick={() => handleAddLinea()}
                  >
                    <AddCircleOutline fontSize="small" />
                  </IconButton>
                </span>
              </Tooltip>
            </Grid>
          </Grid>
        ))}

      </Paper>
    </div>
  )
}



 /* <Grid item xs={12} sm={3}>
  <FormControl fullWidth size="small" focused required sx={style}>
    <InputLabel>Imputado a</InputLabel>
    <Select
      onChange={(e) => handleInputChange(index, "id_imputacion", e.target.value)}
      value={datosCuerpo[key].id_imputacion || ""}
      label="Imputado a"
    >
      {imputaciones && imputaciones.map(({ idimputacion, descripcion }) => (
        <MenuItem key={idimputacion} value={idimputacion}>
          {descripcion}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid> */


// const handlePorcentajeIvaChange = (index, id_porcentajeiva) => {
//   // setFormValues((prevValues) => {
//   setdatosCuerpo((prevValues) => {
//     const updatedValues = [...prevValues]
//     const updatedItem = { ...updatedValues[index], id_porcentajeiva }

//     const { subtotalIva, valorIva } = calculateSubtotalIva(updatedItem.subtotal, id_porcentajeiva)
//     updatedItem.subtotal_iva = props.formatNumber(subtotalIva.replace(".", ","))

//     updatedValues[index] = updatedItem

//     updateDatosCuerpo(updatedValues)
//     return updatedValues
//   })
// }


/*  
{Object.keys(datosCuerpo).map((key, index) => (
          <Grid container spacing={1} alignItems="center" direction={{ xs: "column", sm: "row" }} justifyContent={"space-between"} mt={0.5} key={index}>
            <Grid item xs={12} sm={3.5} >
              <TextField
                required
                label="Descripción"
                autoComplete="off"
                type="text"
                sx={style}
                // value={formValues[key].detalle_productos || ""}
                value={datosCuerpo[key].detalle_productos || ""}
                onChange={(e) => handleInputChange(index, "detalle_productos", e.target.value)}
                size="small"
                focused
                name="detalle_productos"
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={1.5}>
              <TextField
                label="Neto"
                autoComplete="off"
                type="text"
                required
                sx={style}
                // value={formValues[key].subtotal || ""}    
                value={datosCuerpo[key].subtotal || ""}
                onKeyPress={(event) => {
                  const { value } = event.target;

                  if (!/[\d,]/.test(event.key)) {
                    event.preventDefault();
                  }

                  if (event.key === "," && value.includes(",")) {
                    event.preventDefault();
                  }
                }} //coma para los decimales            
                // onChange={(e) => handleInputChange(index, "subtotal", Number.parseFloat(e.target.value))}
                onChange={(e) => handleInputChange(index, "subtotal", props.formatNumber(e.target.value))}
                size="small"
                focused
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={1.5}>
              <FormControl fullWidth size="small" focused sx={style} required>
                <InputLabel>Alícuota IVA (%)</InputLabel>
                <Select
                  // value={formValues[key].id_porcentajeiva || ""}
                  value={datosCuerpo[key].id_porcentajeiva || ""}
                  onChange={(e) => handlePorcentajeIvaChange(index, e.target.value)}
                  label="Alícuota IVA (%)"
                  name="id_porcentajeiva"
                >
                  {valorPorcentajes.map(({ idporcentaje_iva, descripcion }) => (
                    <MenuItem key={idporcentaje_iva} value={idporcentaje_iva}>
                      {descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={1.5}>
              <TextField
                required
                label="IVA"
                name="subtotal_iva"
                type="text"
                autoComplete="off"
                // value={formValues[key].subtotal_iva || ""}
                value={datosCuerpo[key].subtotal_iva || ""}
                onChange={(e) => handleInputChange(index, "subtotal_iva", e.target.value)}
                size="small"
                sx={style}
                focused
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={1.5}>
              <FormControl fullWidth size="small" focused sx={style} required>
                <InputLabel>Imputado a</InputLabel>
                <Select
                  onChange={(e) => handleInputChange(index, "id_imputacion", e.target.value)}
                  value={datosCuerpo[key].id_imputacion || ""}
                  label="Imputado a"
                  name="id_imputacion"
                >
                  {imputaciones && imputaciones.map(({ idimputacion, descripcion }) => (
                    <MenuItem key={idimputacion} value={idimputacion}>
                      {descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={1} sx={{ display: "flex", justifyContent: "center" }}>
              <Tooltip title="Eliminar linea">
                <IconButton
                  sx={{
                    color: "#e74c3c",
                    "&:hover": { backgroundColor: "#fadbd8" },
                  }}
                  onClick={() => deshacerLinea(index)}
                  // disabled={formValues && index === 0}
                  disabled={datosCuerpo && index === 0}
                >
                  <Delete />
                </IconButton>
              </Tooltip>
              <Tooltip title="Nueva Línea">
                <IconButton
                  // disabled={index !== formValues.length - 1}
                  disabled={index !== datosCuerpo.length - 1 || !datosCuerpo[0].subtotal}
                  sx={{
                    color: "#1f618d",
                    "&:hover": { backgroundColor: "#d4e6f1" },
                  }}
                  onClick={() => handleAddLinea()}
                >
                  <AddCircleOutline />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        ))} */ 

        
  // const calculateSubtotalIva = (subtotal, id_porcentajeiva) => {
  //   const subtotalok = subtotal.replace(/\./g, "").replace(/,/g, ".")
  //   const porcentajeItem = valorPorcentajes.find((item) => item.idporcentaje_iva === id_porcentajeiva)
  //   // console.log("porcentaje item", porcentajeItem);

  //   const porcentajeIva = porcentajeItem ? porcentajeItem.valor : 0
  //   // console.log("porcentaje valor", porcentajeIva);

  //   const subtotalIva = subtotalok ? (subtotalok * porcentajeIva).toFixed(2) : null

  //   return {
  //     subtotalIva,
  //   }
  // }

  // console.log("valoresporcentjae", valorPorcentajes);

